import { dosdoc_details_arr } from "./DossDocConstants.js";
import MultipleFormBoxComp from "../../components/FormBox/MultipleFormBoxComp";
import { useForm } from "react-hook-form";
import { LiHandleButton } from "../../Utils/CustomComponent";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "../../axios";
import urls from "../../Utils/urls";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils/index.js";
import AttachmentsSection from "./AttachmentsSection.jsx";
import { useAbortController } from "../../hooks/useAbortController.js";

const DossDocEditPage = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onBlur" });

  const [activeTab, setActiveTab] = useState(0);
  const [dossDoccFormData, setDossDoccFormData] = useState(null);
  const { signal } = useAbortController();

  let { id } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const authToken = await axios.get(urls.dashboard.getDossDocToken());
        const res = axios
          .get(
            urls.dosssdoc.getDossDoc(id),
            // `https://api-p.loanlinq.com/ords/loanlinq/v1/dossdoc/get_dossdoc_by_doc/${id}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken.data.token}`,
              },
            },
            { signal }
          )
          .then((res) => {
            setDossDoccFormData(res.data.items);
          });
      } catch (error) {
        if (error.name === "CanceledError") {
          console.error("Fetch request canceled", error.message);
        } else {
          console.error(error);
        }
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (dossDoccFormData && dossDoccFormData.length > 0) {
      Object.keys(dossDoccFormData[0])?.forEach((key) => {
        setValue(key, dossDoccFormData[0][key]);
      });
    }
  }, [dossDoccFormData, setValue]);

  const onSubmit = (data) => {
    // setSubmitLoading(true);
    const id = toast.loading("Submission Pending");

    try {
      // Simulate successful submission
      setTimeout(() => {
        toast.update(id, {
          render: "Loan Submitted Successfully",
          type: "success",
          isLoading: false,
          ...commonToast,
        });
        // setSubmitLoading(false);
      }, 2000); // Simulate API call delay with setTimeout
    } catch (error) {
      console.error(error);
      toast.error("Submission Failed");
      //   setSubmitLoading(false);
    } finally {
      setTimeout(() => {
        toast.dismiss();
      }, 3000);
    }
  };

  const handleBtnClick = (value) => {
    const func = () => setActiveTab(value);
    func();
    // handleSubmit(onSubmit)(func);
  };

  return (
    <div
      className="text-start container-fluid my-0 px-0"
      style={{ overflowY: "scroll" }}
    >
      <section
        className=" rounded py-5 px-4"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid">
          <ul className="nav nav-tabs bg-white">
            {tabButtons?.map((data, index) => (
              <LiHandleButton
                key={index}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                label={data.label}
                value={index}
                handleBtnClick={handleBtnClick}
              />
            ))}
          </ul>
          <div className="bg-white">
            {activeTab === 0 &&
              dosdoc_details_arr?.map((data, index) => (
                <MultipleFormBoxComp
                  key={index}
                  register={register}
                  watch={watch}
                  setValue={setValue}
                  options={data.arr}
                  errors={errors}
                />
              ))}
            {activeTab === 0 && (
              <button
                onClick={handleSubmit(onSubmit)}
                className="btn btn-primary text-white mt-3 mb-5"
              >
                Submit
              </button>
            )}
            {activeTab === 1 && <AttachmentsSection />}
          </div>
        </article>
      </section>
    </div>
  );
};

export default DossDocEditPage;

let tabButtons = [
  {
    label: <p>Details</p>,
  },
  {
    label: <p>Attachments</p>,
  },
];
